/**
 * Crop image centered on face bounding box.
 * Crop params: 50px horizontal, 150px vertical padding; JPEG 0.9.
 */

const PAD_H = 50;
const PAD_V = 150;

/**
 * Crop image blob to face-centered region and return as JPEG blob.
 * @param {Blob} blob - Full captured image
 * @param {Object} bbox - Face bounding box { originX, originY, width, height }
 * @param {number} imageWidth - Full image width
 * @param {number} imageHeight - Full image height
 * @returns {Promise<Blob>}
 */
export function cropToFaceCentered(blob, bbox, imageWidth, imageHeight) {
	return new Promise((resolve, reject) => {
		const left = Math.max(bbox.originX - PAD_H, 0);
		const top = Math.max(bbox.originY - PAD_V, 0);
		const width = Math.min(bbox.width + 2 * PAD_H, imageWidth - left);
		const height = Math.min(bbox.height + 2 * PAD_V, imageHeight - top);

		const canvas = document.createElement('canvas');
		canvas.width = width;
		canvas.height = height;
		const ctx = canvas.getContext('2d');

		const img = new Image();
		const url = URL.createObjectURL(blob);
		img.onload = () => {
			try {
				ctx.drawImage(img, left, top, width, height, 0, 0, width, height);
				URL.revokeObjectURL(url);
				canvas.toBlob(
					(resultBlob) => {
						if (resultBlob) {
							resolve(resultBlob);
						} else {
							reject(new Error('Failed to create blob'));
						}
					},
					'image/jpeg',
					0.9,
				);
			} catch (err) {
				URL.revokeObjectURL(url);
				reject(err);
			}
		};
		img.onerror = () => {
			URL.revokeObjectURL(url);
			reject(new Error('Failed to load image'));
		};
		img.src = url;
	});
}
